var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: _vm.loading ? "container-loading" : "",
      attrs: {
        fluid: !_vm.loading,
        "grid-list-lg": !_vm.loading,
        "fill-height": _vm.loading
      }
    },
    [
      !_vm.loading
        ? _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-slide-y-transition",
                    { attrs: { mode: "out-in" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "hidden-sm-and-down",
                              attrs: { xs12: "", sm3: "" }
                            },
                            [
                              _c(
                                "v-slide-y-transition",
                                { attrs: { mode: "out-in" } },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-center mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "v-icon-avatar"
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { dark: "" } },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    $mdiAdobeAcrobat\n                                                "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            {
                                              attrs: {
                                                "two-line": "",
                                                subheader: ""
                                              }
                                            },
                                            [
                                              _vm.quotation.name
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        Name\n                                                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .quotation
                                                                      .name
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.quotation.reference_number
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        Reference number\n                                                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .quotation
                                                                      .reference_number
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.quotation.version
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        Version\n                                                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .quotation
                                                                      .version
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.quotation.iteration
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        Iteration\n                                                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .quotation
                                                                      .iteration
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.quotation.created_at
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        Created at\n                                                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .quotation
                                                                      .created_at
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.quotation.updated_at
                                                ? _c(
                                                    "v-list-item",
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        Updated at\n                                                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              class: _vm.isDark
                                                                ? "white--text"
                                                                : "primary--text"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .quotation
                                                                      .updated_at
                                                                  ) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md9: "" } },
                            [
                              _c(
                                "v-slide-y-transition",
                                { attrs: { mode: "out-in" } },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-tabs",
                                            {
                                              staticClass: "mobile-tabs",
                                              attrs: {
                                                centered: "",
                                                "icons-and-text": "",
                                                "mobile-break-point": "320"
                                              },
                                              on: {
                                                change: _vm.setTabParameter
                                              },
                                              model: {
                                                value: _vm.activeTab,
                                                callback: function($$v) {
                                                  _vm.activeTab = $$v
                                                },
                                                expression: "activeTab"
                                              }
                                            },
                                            [
                                              _c("v-tabs-slider", {
                                                attrs: { color: "secondary" }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab",
                                                {
                                                  class: _vm.isDark
                                                    ? "white--text"
                                                    : "primary--text",
                                                  attrs: { href: "#info" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                Information\n                                                "
                                                  ),
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "$mdiInformationOutline"
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                { attrs: { value: "info" } },
                                                [
                                                  _vm.activeTab === "info"
                                                    ? _c("item-info", {
                                                        attrs: {
                                                          "item-info":
                                                            _vm.quotation
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab",
                                                {
                                                  class: _vm.isDark
                                                    ? "white--text"
                                                    : "primary--text",
                                                  attrs: { href: "#summary" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                Summary\n                                                "
                                                  ),
                                                  _c("v-icon", [
                                                    _vm._v("$mdiFileTable")
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                { attrs: { value: "summary" } },
                                                [
                                                  _vm.activeTab === "summary" &&
                                                  _vm.quotation.type === 1
                                                    ? _c("my-cover-summary", {
                                                        attrs: {
                                                          "item-info":
                                                            _vm.quotation
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.activeTab === "summary" &&
                                                  _vm.quotation.type === 2
                                                    ? _c(
                                                        "home-vantage-summary",
                                                        {
                                                          attrs: {
                                                            "item-info":
                                                              _vm.quotation
                                                          }
                                                        }
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              typeof _vm.quotation.holders !==
                                                "undefined" &&
                                              _vm.quotation.holders.length
                                                ? _c(
                                                    "v-tab",
                                                    {
                                                      class: _vm.isDark
                                                        ? "white--text"
                                                        : "primary--text",
                                                      attrs: { href: "#client" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Client\n                                                "
                                                      ),
                                                      _c("v-icon", [
                                                        _vm._v("$mdiAccount")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                { attrs: { value: "client" } },
                                                [
                                                  _vm.activeTab === "client"
                                                    ? _c("item-client", {
                                                        attrs: {
                                                          "item-info":
                                                            _vm.quotation
                                                              .holders[0]
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              typeof _vm.quotation.holders !==
                                                "undefined" &&
                                              _vm.quotation.holders.length &&
                                              typeof _vm.quotation.holders[0]
                                                .current_policy !==
                                                "undefined" &&
                                              _vm.quotation.holders[0]
                                                .current_policy
                                                ? _c(
                                                    "v-tab",
                                                    {
                                                      class: _vm.isDark
                                                        ? "white--text"
                                                        : "primary--text",
                                                      attrs: { href: "#policy" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                Policy\n                                                "
                                                      ),
                                                      _c("v-icon", [
                                                        _vm._v("$mdiHistory")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-tab-item",
                                                { attrs: { value: "policy" } },
                                                [
                                                  _vm.activeTab === "policy"
                                                    ? _c("item-policy", {
                                                        attrs: {
                                                          "item-info":
                                                            _vm.quotation
                                                              .holders[0]
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-layout",
            { attrs: { "justify-center": "", "align-center": "", column: "" } },
            [
              _c("v-progress-circular", {
                attrs: { size: 50, color: "secondary", indeterminate: "" }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }